import { login, logout, getInfo } from '../../api/login'
import { getToken, setToken, removeToken } from '../../utils/auth'

const user = {
  state: {
    token: getToken(),
    username: '',
    rules: '',
    web_site_name: '',
    id:"",
    pici:"",
    realname:""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_RULES: (state, rules) => {
      state.rules = rules
    },
    SET_WEB_SITE_NAME: (state, web_site_name) => {
      state.web_site_name = web_site_name
    },
    SET_ID: (state, name) => {
      state.id = name
    },
    SET_PICI: (state, piciId) => {
      state.pici = piciId
    },
    setRealname: (state, realname) => {
      state.realname = realname
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          setToken(data.token)
          commit('SET_TOKEN', data.token)
          commit('SET_ID', data.id)
          commit('SET_PICI', data.piciId)
          commit('setRealname', data.realname)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data
          commit('SET_USERNAME', data.username)
          commit('SET_RULES', data.rules)
          commit('SET_WEB_SITE_NAME', data.webSiteName)
          commit('SET_ID', data.id)
          commit('SET_PICI', data.piciId)
          commit('setRealname', data.realname)
          document.title = data.webSiteName + '-管理员'
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js